// A fejlesztés-tétel ENUM-készletei EGY helyen — a form, a lista-szűrők és a jelvények ugyanezt olvassák.
// A készlet a `@atlas/contracts` sémáiból származik (ott a forrás-igazság); itt a MEGJELENÍTÉSI sorrend él,
// mert az információ: a `stage` a haladás sorrendjében, a `horizon` a Most → Következik → Később rendben.
import type {
  ProductUpdateHorizon,
  ProductUpdateStage,
  ProductUpdateStatus,
  ProductUpdateType,
} from '@atlas/contracts';

export const PRODUCT_UPDATE_STAGES: readonly ProductUpdateStage[] = [
  'idea',
  'planned',
  'in_progress',
  'shipped',
  'on_hold',
  'cancelled',
];

export const PRODUCT_UPDATE_TYPES: readonly ProductUpdateType[] = [
  'feature',
  'improvement',
  'fix',
  'security',
  'performance',
];

export const PRODUCT_UPDATE_HORIZONS: readonly ProductUpdateHorizon[] = ['now', 'next', 'later'];

export const PRODUCT_UPDATE_STATUSES: readonly ProductUpdateStatus[] = [
  'draft',
  'published',
  'archived',
];
